import { Layout } from "../components/layout/Layout";
import { Accordion } from "../components/stats/Accordion";
import { useState } from "react";
import { useTranslation } from "../translations/LanguageContext";

export function Features() {
    const [openAccordion, setOpenAccordion] = useState("")
    const { t } = useTranslation();

    // Small helper so each accordion's "computations" list only needs
    // one line below, instead of repeating the intro + <ul> boilerplate.
    function ComputationsList({ items }) {
        return (
            <>
                <p className="accordion-text">{t("featuresPage.computationsIntro")}</p>
                <ul>
                    {items.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
            </>
        );
    }

    return (
        <Layout>
            <section className="page-header">
                <div className="page-header-left">
                    <h1 className="page-title">{t("featuresPage.title")}</h1>
                    <h2 className="page-subtitle">{t("featuresPage.subtitle")}</h2>
                </div>
            </section>
            <section className="accordion-gallery">
                <Accordion title={t("featuresPage.surface.title")} open={openAccordion === "surface"} onToggle={() => setOpenAccordion(current => current === "surface" ? null : "surface")}>
                    <p className="accordion-text">{t("featuresPage.surface.body")}</p>
                    <ComputationsList items={t("featuresPage.surface.computations")} />
                </Accordion>

                <Accordion title={t("featuresPage.vocab.title")} open={openAccordion === "vocab"} onToggle={() => setOpenAccordion(current => current === "vocab" ? null : "vocab")}>
                    <p className="accordion-text">{t("featuresPage.vocab.body")}</p>
                    <ComputationsList items={t("featuresPage.vocab.computations")} />
                </Accordion>

                <Accordion title={t("featuresPage.pos.title")} open={openAccordion === "pos"} onToggle={() => setOpenAccordion(current => current === "pos" ? null : "pos")}>
                    <p className="accordion-text">{t("featuresPage.pos.body")}</p>
                    <p className="accordion-text">{t("featuresPage.pos.listIntro")}</p>
                    <ul>
                        {t("featuresPage.pos.items").map((item, i) => (
                            <li key={i}>
                                <strong>{item.term}</strong> {item.description}
                                {item.term === "Verbs:" && (
                                    <>
                                        <p className="accordion-text">{t("featuresPage.pos.tensesIntro")}</p>
                                        <ul>
                                            {t("featuresPage.pos.tenses").map((tense, j) => <li key={j}>{tense}</li>)}
                                        </ul>
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                    <ComputationsList items={t("featuresPage.pos.computations")} />
                </Accordion>

                <Accordion title={t("featuresPage.mutations.title")} open={openAccordion === "mutations"} onToggle={() => setOpenAccordion(current => current === "mutations" ? null : "mutations")}>
                    <p className="accordion-text">{t("featuresPage.mutations.body")}</p>
                    <ComputationsList items={t("featuresPage.mutations.computations")} />
                </Accordion>

                <Accordion title={t("featuresPage.syntactic.title")} open={openAccordion === "syntactic"} onToggle={() => setOpenAccordion(current => current === "syntactic" ? null : "syntactic")}>
                    <p className="accordion-text">{t("featuresPage.syntactic.body")}</p>
                    <ComputationsList items={t("featuresPage.syntactic.computations")} />
                </Accordion>
            </section>
        </Layout>
    )
}
